import React from "react";
import config from "../data/siteConfig";
import { Ornament, BandhaniField } from "./Decor";
import { FiMapPin, FiPhone, FiClock, FiArrowRight } from "react-icons/fi";
import { FaWhatsapp, FaFacebookF, FaInstagram, FaGoogle } from "react-icons/fa";

export default function Visit() {
  const c = config.contact;
  const row = (Ic, title, body) => (
    <div className="flex gap-4 border-b border-gold/20 py-4 last:border-0">
      <Ic className="mt-1 shrink-0 text-xl text-gold-light" />
      <div>
        <strong className="block font-display tracking-wide text-gold-light">{title}</strong>
        <div className="mt-0.5 text-sm text-cream/85">{body}</div>
      </div>
    </div>
  );

  return (
    <section id="visit" className="relative py-20 md:py-28">
      <div className="container-x">
        <div className="text-center">
          <span className="eyebrow">Come See Us</span>
          <h2 className="mt-2 font-display text-3xl text-coffee-800 sm:text-4xl">Visit Our Showroom</h2>
          <div className="mt-3 flex justify-center"><Ornament /></div>
        </div>

        <div className="mt-12 grid overflow-hidden rounded-xl border-2 border-gold/60 shadow-vintage md:grid-cols-2">
          <div className="relative overflow-hidden bg-coffee-grad p-8 text-cream md:p-11">
            <BandhaniField className="absolute inset-0 text-gold" opacity={0.06} />
            <div className="relative">
              <h3 className="font-display text-2xl text-gold-light">{config.brand.name}</h3>
              <p className="gu mt-0.5 text-gold-light/80">{config.brand.nameGu}</p>

              {row(FiMapPin, "Address", (
                <>
                  {c.addressLine1}<br />{c.addressLine2}<br />{c.addressLine3}
                </>
              ))}
              {row(FiPhone, "Call Us", (
                <>
                  <a className="hover:text-gold-light" href={`tel:${c.phonePrimary.replace(/\s/g, "")}`}>{c.phonePrimary}</a> ({c.phonePrimaryName})
                </>
              ))}
              {row(FiClock, "Opening Hours", c.hours)}

              <div className="mt-6 flex flex-wrap gap-3">
                <a className="btn btn-gold" href={`https://wa.me/${c.whatsapp}`} target="_blank" rel="noreferrer"><FaWhatsapp /> WhatsApp Us</a>
                <a className="btn btn-ghost" href={c.mapLink} target="_blank" rel="noreferrer">Get Directions <FiArrowRight /></a>
              </div>

              {/* social media */}
              <div className="mt-6 border-t border-gold/20 pt-5">
                <span className="text-[0.72rem] uppercase tracking-[0.2em] text-gold-light/80">Follow Us</span>
                <div className="mt-3 flex gap-3">
                  {[
                    [FaFacebookF, "Facebook", c.social.facebook],
                    [FaInstagram, "Instagram", c.social.instagram],
                    [FaGoogle, "Google Reviews", c.social.googleReviews],
                  ].map(([Ic, label, href]) => (
                    <a
                      key={label}
                      href={href}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={label}
                      title={label}
                      className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 bg-coffee-950/40 text-lg text-gold-light transition-colors hover:bg-gold hover:text-coffee-900"
                    >
                      <Ic />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="min-h-[360px] md:min-h-full">
            <iframe
              title="Shree Abhushan Jewellers location"
              src={c.mapEmbed}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              className="h-full min-h-[360px] w-full border-0 [filter:sepia(0.3)_saturate(1.1)]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
